import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-241cc2ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "question-sub-caption" }, "Перетащите ответы в нужной последовательности", -1))
const _hoisted_2 = { class: "compliance-component" }
const _hoisted_3 = { class: "order-list-wrapper" }
const _hoisted_4 = ["onDrop"]
const _hoisted_5 = ["onDragstart"]
const _hoisted_6 = ["onDragstart"]

import IAnswer from "@/interfaces/IAnswer";
import { useTestStore } from "@/store/UserTestModule";
import { computed, onMounted, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderQuestionComponent',
  setup(__props, { expose: __expose }) {

const testStore = useTestStore();
const currentQuestion = computed(() => {
  return testStore.currentQuestion;
});

const droppableItemWrapper = ref();
const droppableItem = ref();

function fontSizeComputed(textLength: number) {
  if (droppableItemWrapper.value) {
    let font =
      (droppableItemWrapper.value.offsetWidth - 100) / (textLength / 2);
    if (font > 24) {
      return "24px";
    } else if (font < 14) {
      return "14px";
    } else {
      return (
        (
          (droppableItemWrapper.value.offsetWidth - 100) /
          (textLength / 2)
        ).toFixed(0) + "px"
      );
    }
  } else return "24px";
}

const isNextDisabledOrder = computed(() => {
  if (droppableItem.value) {
    return droppableItem.value.length !== 0;
  } else {
    return false;
  }
});

function dragAnswerStart(event: DragEvent, item: any) {
  if (event.dataTransfer != undefined) {
    event.dataTransfer.dropEffect = "move";
    event.dataTransfer.effectAllowed = "move";
    event.dataTransfer.setData("itemId", item.answerId);
  }
  event.target.classList.add("dragging");
}

function onDropAnswer(event: any, index: number) {
  const itemId = event.dataTransfer.getData("itemId");
  const answer = currentQuestion.value.answers.find(
    (item: IAnswer) => item.answerId == itemId
  );
  answer.answerUser = index.toString();
  checkAnswers(itemId, index);
  testStore.setUserAnswer(currentQuestion.value);
}

function onReturnAnswer(event: any, value: null) {
  const itemId = event.dataTransfer.getData("itemId");
  const answer = currentQuestion.value.answers.find(
    (item: IAnswer) => item.answerId == itemId
  );
  answer.answerUser = value;
  testStore.setUserAnswer(currentQuestion.value);
}

function dragAnswerEnd(event: DragEvent) {
  event.target.classList.remove("dragging");
}

function checkAnswers(itemId, index) {
  if (
    currentQuestion.value.answers.filter((item) => item.answerUser == index)
      .length > 1
  ) {
    currentQuestion.value.answers
      .filter((item) => item.answerUser == index)
      .forEach((element) => {
        if (element.answerId != itemId) {
          element.answerUser = null;
        }
      });
  }
}

__expose({
  isNextDisabledOrder,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentQuestion.value.answers, (answer, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "order-list-wrapper__item order-list-wrapper__count-item",
            key: index + 1,
            onDrop: ($event: any) => (onDropAnswer($event, index + 1)),
            onDragenter: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
            onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createTextVNode(_toDisplayString(index + 1) + " ", 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentQuestion.value.answers.filter(
            (item) => item.answerUser == index + 1
          ), (answer, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "order-list-wrapper__item order-list-wrapper__text-item order-list-wrapper__text-item__after",
                key: index,
                style: _normalizeStyle('font-size:' + fontSizeComputed(answer.text.length)),
                draggable: "true",
                onDragstart: ($event: any) => (dragAnswerStart($event, answer))
              }, _toDisplayString(answer.text), 45, _hoisted_5))
            }), 128))
          ], 40, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("div", {
        class: "order-list-wrapper",
        onDrop: _cache[3] || (_cache[3] = ($event: any) => (onReturnAnswer($event, null))),
        onDragenter: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
        onDragover: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
        ref_key: "droppableItemWrapper",
        ref: droppableItemWrapper
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentQuestion.value.answers.filter(
          (item) => item.answerUser == null
        ), (answer, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "order-list-wrapper__text-item order-list-wrapper__item",
            key: index,
            style: _normalizeStyle('font-size:' + fontSizeComputed(answer.text.length)),
            ref_for: true,
            ref_key: "droppableItem",
            ref: droppableItem,
            draggable: "true",
            onDragstart: ($event: any) => (dragAnswerStart($event, answer)),
            onDragend: _cache[2] || (_cache[2] = ($event: any) => (dragAnswerEnd($event)))
          }, _toDisplayString(answer.text), 45, _hoisted_6))
        }), 128))
      ], 544)
    ])
  ], 64))
}
}

})